import dayjs from "dayjs";
import "dayjs/locale/de";
import { gradArray } from "../../../../components/form/fields/inputFields";

export const EMPTY_ARRAY = [];
export const RECENT_ATTENDEES_LIMIT = 10;
export const ATTENDANCE_LAST_SITE_KEY = "attendance:lastSiteId";
export const ATTENDANCE_RECENT_ATTENDEES_KEY = "attendance:recentAttendeesBySite";

export const toId = (value) => {
  if (!value) return "";
  return String(value?._id || value?.id || value);
};

export const toSiteLabel = (site) => String(site?.siteName || "");

export const toDateInputValue = (value = new Date()) =>
  dayjs(value).format("YYYY-MM-DD");

export const toTimeInputValue = (value = new Date()) =>
  dayjs(value).format("HH:mm");

export const toLocalDateLabel = (value) => dayjs(value).format("ddd, DD MMM YYYY");

export const toLocalTimeLabel = (value) => dayjs(value).format("HH:mm");

export const toDateRangeFromPreset = ({ preset, customDate }) => {
  const now = dayjs();
  let target = now;

  if (preset === "yesterday") {
    target = now.subtract(1, "day");
  }
  if (preset === "custom" && customDate) {
    target = dayjs(customDate);
  }

  const start = target.startOf("day");
  const end = target.endOf("day");

  return {
    selectedDate: target.format("YYYY-MM-DD"),
    from: start.toISOString(),
    to: end.toISOString(),
  };
};

export const toStartAtIso = ({ dateValue, timeValue }) => {
  const parsed = dayjs(`${dateValue}T${timeValue}`);
  if (!parsed.isValid()) return null;
  return parsed.toISOString();
};

export const formatMemberName = (member = {}) =>
  `${member?.firstName || ""} ${member?.lastName || ""}`.trim() || "Mitglied";

dayjs.locale("de");

export const formatDegreeLabel = (degree) => {
  if (degree == null || degree === "") return "";
  const numeric = Number(degree);
  if (Number.isFinite(numeric)) {
    const match = gradArray.find((grad) => Number(grad.value) === numeric);
    return match?.label || "";
  }
  const normalized = String(degree).trim();
  return normalized;
};

const safeJsonParse = (value, fallback) => {
  try {
    const parsed = JSON.parse(value);
    return parsed ?? fallback;
  } catch (error) {
    return fallback;
  }
};

export const readRecentAttendeesBySite = (siteId) => {
  if (!siteId || typeof window === "undefined") return EMPTY_ARRAY;
  const raw = window.localStorage.getItem(ATTENDANCE_RECENT_ATTENDEES_KEY);
  const parsed = safeJsonParse(raw, {});
  const entries = Array.isArray(parsed?.[siteId]) ? parsed[siteId] : EMPTY_ARRAY;
  return entries.slice(0, RECENT_ATTENDEES_LIMIT);
};

export const writeRecentAttendeesBySite = (siteId, attendees) => {
  if (!siteId || typeof window === "undefined") return EMPTY_ARRAY;

  const raw = window.localStorage.getItem(ATTENDANCE_RECENT_ATTENDEES_KEY);
  const parsed = safeJsonParse(raw, {});
  const current = Array.isArray(parsed?.[siteId]) ? parsed[siteId] : EMPTY_ARRAY;

  const deduped = new Map();
  [...attendees, ...current].forEach((attendee) => {
    const attendeeId = toId(attendee);
    if (!attendeeId || deduped.has(attendeeId)) return;
    deduped.set(attendeeId, {
      _id: attendeeId,
      firstName: String(attendee?.firstName || ""),
      lastName: String(attendee?.lastName || ""),
      memberNumber: String(attendee?.memberNumber || ""),
      degree:
        typeof attendee?.degree === "number"
          ? attendee.degree
          : attendee?.degree ?? null,
      standortRef: attendee?.standortRef
        ? {
            _id: toId(attendee.standortRef),
            siteName: String(attendee?.standortRef?.siteName || ""),
          }
        : null,
    });
  });

  const nextList = Array.from(deduped.values()).slice(0, RECENT_ATTENDEES_LIMIT);
  const payload = { ...parsed, [siteId]: nextList };
  window.localStorage.setItem(
    ATTENDANCE_RECENT_ATTENDEES_KEY,
    JSON.stringify(payload),
  );

  return nextList;
};

export const getInitials = (value) => {
  const safe = String(value || "").trim();
  if (!safe) return "M";
  const parts = safe.split(/\s+/).slice(0, 2);
  return parts.map((part) => part.charAt(0).toUpperCase()).join("") || "M";
};
